export default "/kiban/_next/static/images/chamferingProcess-e87814501032b1ea79f28ef6d5446e5c.png";